import React, { useContext, useEffect } from "react";
import { Link, useLoaderData, useNavigate } from "react-router-dom";
import useUserData from "./helpers/userData";
import { tokenState, UserContext } from "./Home";
import { useAtomValue } from "jotai";
import { BasicGridAppBoxes } from "./AppBoxes";
import useFetch from "./helpers/useFetch";
import { NavBar } from "./Base";
import { useDeviceWidth } from "./useDeviceWidth";
import { PageHeaderLink } from "./helpers/elements";
import useTokenData from "./helpers/tokenData";
import { getSocialAccountHandle } from "./helpers/utils";
import { getProfile } from "./loaders/appLoaders";

export async function loader() {
    const me = await getProfile();
    return { me };
}

export const UserPageComponent = ({ userId, userData }) => {
    const { windowWidth, screenWidth, deviceWidthEnum } = useDeviceWidth();
    // const { rawToken, isLoggedIn, tokenData } = useAtomValue(tokenState);
    const { rawToken, isLoggedIn, tokenData } = useTokenData();
    // const navigate = useNavigate();
    // const user = useContext(UserContext);
    // const [userApps] = useFetch(`${process.env.REACT_APP_BASE_URL}/user/${tokenData?.user_id}/apps/`);
    const [userApps] = useFetch(`${process.env.REACT_APP_BASE_URL}/user/${userId}/apps/`);
    const [socialSitesList] = useFetch(`${process.env.REACT_APP_BASE_URL}/app/social_list/`);

    return (
        <section className={"profile-container bg-light lg:bg-white-solid dark:bg-111314"}>
            {
                windowWidth >= deviceWidthEnum.laptop
                    ? <NavBar showProfile={false} />
                    : null
            }
            {
                // For devices smaller than the laptop
                windowWidth < deviceWidthEnum.laptop
                    ? <PageHeaderLink headerTitle={userId === tokenData?.user_id ? "My profile" : `${userData?.firstname} Page`} fixTop={true}>
                        {
                            userId === tokenData?.user_id
                                ? <Link to={"/profile/update"}
                                    className={"abs px:top-20 right-4 h-5 lh-5 bg-green radius pad-x2 decoration-none color-white"}>
                                    Edit
                                    <span className={"fa fa-pen pad-l1 color-white"}></span>
                                </Link>
                                : null
                        }
                    </PageHeaderLink>
                    : null
            }
            {
                // For devices smaller than the laptop
                windowWidth < deviceWidthEnum.laptop
                    ? <PageHeaderLink noFix={true} />
                    : null
            }
            {/*Profile Page*/}
            {
                // For devices smaller than the laptop
                windowWidth < deviceWidthEnum.laptop
                    ? <div className={"relative flex flex-column justify-center align-items-center flex-basis flex-grow pad-t8 pad-b4 bg-white-solid overflow-hidden z-10 dark:bg-000304|color-whitesmoke"}>
                        <div className={"flex flex-row abs neg:top-20 neg:left-20 pct:w-120 lh-normal color-F8FBF8 font-120 font-bold text-center overflow-hidden lg:pct:w-100|neg:top-10|left-5 dark:color-11131466"}>
                            {userData?.firstname}
                        </div>
                        <div className={"flex flex-row abs top-0 neg:left-20 pct:w-120 lh-normal color-F8F8F8 font-120 font-bold text-right overflow-hidden lg:pct:w-100|left-50 dark:color-11131466"}>{userData?.lastname}</div>
                        {
                            userData?.dp
                                ? <img alt=""
                                    className="sibling-user relative square-12 lh-12 radius-circle bg-lighter border-0 border-DDD border-solid bg-light cursor-pointer object-fill object-center hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease lg:square2-6|lh2-6"
                                    src={userData?.dp}
                                />
                                : <div
                                    className={"sibling-user relative square-12 lh-12 radius-circle bg-lighter border-0 border-DDD border-solid bg-light text-center font-bold cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease lg:square2-6|lh2-6 dark:bg-111314|color-whitesmoke dark:hover:shadow:inset-0px-0px-16px-0px-000304 dark:brightness-60"}>
                                    {userData?.firstname?.split('')[0].toUpperCase() + userData?.lastname?.split('')[0].toUpperCase()}
                                </div>
                        }
                        <div className={"d-block font-24 font-semibold pad-t2 pad-b1 lg:font-32|pad-y4 dark:color-darkgray"}>{userData?.firstname} {userData?.lastname}</div>
                        <div className={"relative font-15 font-light lg:font-18|pad-y1"}>{userData?.email || userData?.phone_no}</div>
                        {
                            userData?.tags
                                ? <div className={"relative d-block mg-y2 lg:mg-y5"}>
                                    {
                                        "python, javascript, golang".split(",").map((each_user_skills, index) => {
                                            return (
                                                <span key={index}
                                                    className={"bg-light radius pad-1 mg-x-2 lg:font-13"}>{each_user_skills}</span>
                                            )
                                        })
                                    }
                                </div>
                                : null
                        }
                        {
                            userId === tokenData?.user_id
                                ? <Link to={"/profile/update"} className={"h-5 lh-5 bg-green radius pad-x2 mg-t2 decoration-none color-white"}>Edit <span className={"fa fa-pen pad-l1 color-white"}></span></Link>
                                : null
                        }
                    </div>
                    : null
            }
            {
                // For laptops and devices larger than the laptop
                windowWidth >= deviceWidthEnum.laptop
                    ? <section
                        className={"fixed px:top-80 flex flex-column justify-center align-items-center pct:w-100 h-200 mg-x-auto bg-white-solid text-center lg:relative|px:top-0|h-480|pad-y8|bg-lighter dark:bg-000304"}>
                        {/*Profile Page*/}
                        <div
                            className={"relative flex flex-row justify-center align-items-center flex-basis flex-grow bg-transparent overflow-hidden z-10"}>
                            {
                                userData?.dp
                                    ? <img alt=""
                                        className="relative d-block square-12 lh-12 radius-circle bg-lighter border-0 border-DDD border-solid bg-light cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease lg:square2-12|lh2-12 dark:bg-111314|color-whitesmoke dark:hover:shadow:inset-0px-0px-16px-0px-000304 dark:brightness-60"
                                        src={userData?.dp}
                                    />
                                    : <div
                                        className={"relative d-block square-12 lh-12 radius-circle bg-lighter border-0 border-DDD border-solid bg-light text-center font-bold cursor-pointer hover:shadow:inset-0px-0px-16px-0px-DDD transition:box-shadow_200ms_ease lg:square2-12|lh2-12 dark:bg-111314|color-whitesmoke dark:hover:shadow:inset-0px-0px-16px-0px-000304"}>
                                        {userData?.firstname?.split('')[0].toUpperCase() + userData?.lastname?.split('')[0].toUpperCase()}
                                    </div>
                            }
                            <div
                                className={"d-block font-24 font-semibold pad-x2 pad-t2 pad-b1 lg:font-32|pad-y4 dark:color-darkgray"}>
                                {userData?.firstname} {userData?.lastname}
                                <div
                                    className={"relative font-15 font-light pad-y1 text-left lg:font-18|pad-y3 dark:color-whitesmoke"}>
                                    {userData?.email || userData?.phone_no}
                                </div>
                                {
                                    userData?.tags
                                        ? <div className={"relative d-block text-left mg-y1 lg:mg-y1"}>
                                            {
                                                "python, javascript, golang".split(",").map((each_user_skills, index) => {
                                                    return (
                                                        <span key={index}
                                                            className={"bg-light radius pad-1 mg-x-2 lg:font-13"}>{each_user_skills}</span>
                                                    )
                                                })
                                            }
                                        </div>
                                        : null
                                }
                                {
                                    userId === tokenData?.user_id
                                        ? <Link to={"/profile/update"}
                                            className={"d-block h-5 lh-5 bg-green radius pad-x2 mg-t2 mg-l-auto decoration-none color-white"}>
                                            Edit
                                            <span className={"fa fa-pen pad-l1 color-white"}></span></Link>
                                        : null
                                }
                            </div>
                        </div>
                    </section>
                    : null
            }
            <section className={"flex flex-column pad-t4 pad-b4 bg-white-solid lg:pct:w-64|mg-x-auto dark:bg-inherit|radius-top-right|radius-top-left"}>
                <header className={"font-15 pad-x2 pad-y2 font-medium lg:font-18|pad-y4 dark:color-whitesmoke"}>{"Personal details"}</header>
                {/*{JSON.stringify(userData)}*/}
                <section className={"every:flex|flex-column|mg-y1|pad-2|font-14 dark:color-whitesmoke"}>
                    {
                        userData?.firstname !== ""
                            ? <div className={""}>
                                <span className={"lg:font-16"}>About {userData?.firstname} </span>
                                <span className={"pad-y1 lg:font-13|lh-40"}>
                                    {/* {userData?.about_me || "About me is a service that shows you a summary of each search results, so you can make better choices with your search."} */}
                                    {userData?.about_me || "-"}
                                </span>
                            </div>
                            : null
                    }
                    <div className={""}>
                        <span className={"lg:font-14"}><span className={"fa fa-phone square-4 lh-4 color-999"}></span> Mobile: </span>
                        <a href={`tel:${userData?.phone_no}`} className={"pad-l5 pad-y1 decoration-none color-initial dark:color-whitesmoke"}>{userData?.phone_no || "-"}</a>
                    </div>
                    <div className={""}>
                        <span className={"lg:font-14"}><span className="fa fa-map square-4 lh-4 color-999"></span> Address: </span>
                        <span className={"pad-l5 pad-y1 decoration-none color-initial dark:color-whitesmoke"}>{userData?.address || "-"}</span>
                    </div>
                    <div className={""}>
                        <span className={"lg:font-14"}><span className={"fa fa-flag square-4 lh-4 color-999"}></span> Country: </span>
                        <span className={"pad-l5 pad-y1"}>{userData?.country || "-"}</span>
                    </div>
                    <div className={""}>
                        <span className={"lg:font-14"}><span className="fa fa-calendar-plus square-4 lh-4 color-999"></span>Date Joined: </span>
                        <span className={"pad-l5 pad-y1 color-999"}>{new Date(userData?.date_joined).toLocaleDateString() || "-"}</span>
                    </div>
                </section>
            </section>
            <section className={"flex flex-column mg-y-1 pad-t4 pad-b4 bg-white-solid lg:pct:w-64|mg-x-auto dark:bg-inherit"}>
                {
                    userId === tokenData?.user_id
                        ? <Link to={`/user/${tokenData?.user_id}/apps`} className={"relative pct:w-100 font-15 pad-x2 pad-y2 font-medium radius decoration-none color-initial hover:bg-lighter lg:font-18|pad-y4 dark:color-whitesmoke dark:hover:bg-222425BB"}>
                            {"Your Apps"}
                            <span className={"fa fa-angle-right abs right-4 font-18"}></span>
                        </Link>
                        : <Link to={"apps"} className={"relative pct:w-100 font-15 pad-x2 pad-y2 font-medium radius decoration-none color-initial hover:bg-lighter lg:font-18|pad-y4 dark:color-whitesmoke dark:hover:bg-222425BB"}>
                            {userId === tokenData?.user_id ? "Your Apps" : `${userData?.firstname} Apps`}
                            <span className={"fa fa-angle-right abs right-4 font-18"}></span>
                        </Link>
                }
                <section className={"flex flex-row flex-nowrap justify-start align-items-start pad-x2 overflow-x-auto"}>
                    {
                        userApps?.results?.length > 0
                            ? userApps?.results.map((eachUserApps, index) => {
                                return (
                                    index < 6 ? <BasicGridAppBoxes key={eachUserApps.id} {...eachUserApps} /> : null
                                )
                            })
                            : <div className={"mg-x-auto mg-y1 pad-2 font-14 text-center color-gray"}>No apps yet</div>
                    }
                </section>
                {/*{JSON.stringify(userData)}*/}
                {
                    userData?.clicks > 0
                        ? <section className={"every:flex|flex-column|mg-y1|pad-2|font-14"}>
                            <div className={""}>
                                <span className={""}><span className={"fa fa-eye square-4 lh-4 text-center color-999"}></span> 144 views </span>
                                {/*<span className={"pad-l4 pad-y1"}>{userData?.phone_no || <NotDefined />}</span>*/}
                            </div>
                            <div className={""}>
                                <span className={""}><span className={"fa fa-smile square-4 lh-4 text-center color-999"}></span> 16 reactions (Likes, clap) </span>
                                {/*<span className={"pad-l4 pad-y1"}>{userData?.country || <NotDefined />}</span>*/}
                            </div>
                            <div className={""}>
                                <span className={""}><span className="fa fa-save square-4 lh-4 text-center color-999"></span> 4 saves </span>
                                {/*<span className={"pad-l4 pad-y1"}>{userData?.address || <NotDefined />}</span>*/}
                            </div>
                            <div className={""}>
                                <span className={""}><span className="fa fa-money square-4 lh-4 text-center color-999"></span> 5 Donations (#6000) </span>
                                {/*<span className={"pad-l4 pad-y1"}>{new Date(userData?.date_joined).toLocaleDateString() || <NotDefined />}</span>*/}
                            </div>
                        </section>
                        : null
                }
            </section>
            <section className={"flex flex-column mg-y-1 pad-t4 pad-b4 bg-white-solid lg:pct:w-64|mg-x-auto dark:bg-inherit"}>
                <header className={"relative pct:w-100 font-15 pad-x2 pad-y2 font-medium lg:font-18|pad-y4 dark:color-whitesmoke dark:hover:bg-222425BB"}>
                    {"Social Profile"}
                    <span className={"fa fa-angle-right abs right-4 font-18"}></span>
                </header>
                <section className={"every:flex|flex-column|mg-y1|pad-2|font-14"}>
                    {/*{socialSitesList?.filter(item => Object.keys(userData?.social_account_dict).every(key=>item === userData?.social_account_dict[key]))}*/}
                    {/*{socialSitesList?.filter(item => Object.keys(userData?.social_account_dict).includes(item))}*/}
                    {/*{socialSitesList?.filter(item => Object.keys(userData?.social_account_dict).includes(item)).length}*/}
                    {
                        userData && socialSitesList?.filter(item => Object.keys(userData?.social_account_dict).includes(item)).length > 0
                            ? socialSitesList?.map((socialSite, index) => {
                                if (userData?.social_account_dict[socialSite]) {
                                    return (
                                        <div key={index} className={"dark:color-whitesmoke"}>
                                            <span className={""}>
                                                <span
                                                    className={`fab fa-${socialSite} square-4 lh-4 text-center color-999`}>
                                                </span>
                                                {socialSite}:
                                            </span>
                                            <a href={userData?.social_account_dict[socialSite]}
                                                target={"_blank"}
                                                rel="noreferrer"
                                                className={"pad-l4 pad-y1 font-semibold color-initial dark:color-darkgray"}
                                            >
                                                @{getSocialAccountHandle(userData?.social_account_dict[socialSite])}
                                            </a>
                                        </div>
                                    )
                                }
                            })
                            : <div className={"text-center color-gray"}>No account configured</div>
                    }
                    {/*{Object.keys(userData?.social_account_dict)?.length > 0 ? "" : <div className={"pad-4 text-center"}>No site linked</div>}*/}
                    {/*<div className={""}>
                        <span className={""}><span className="fab fa-instagram square-4 lh-4 text-center color-999"></span>Instagram: </span>
                        <span className={"pad-l4 pad-y1"}>{"-"}</span>
                    </div>*/}
                </section>
            </section>
        </section>
    )
}

function Profile() {
    const { me } = useLoaderData();
    // const {rawToken, isLoggedIn, tokenData} = useTokenData();
    // const {rawToken, isLoggedIn, tokenData} = useRecoilValue(tokenState);
    // const { userDataResults, isError, isLoading, responseDetails } = useUserData();
    useEffect(() => {
        return () => { }
    }, [])

    return (
        // <UserPageComponent userId={userDataResults?.id} userData={userDataResults} />
        <><UserPageComponent userId={me?.data?.id} userData={me?.data} /></>
    );
}

export default Profile;